import { useEffect } from "react";
import { apiFetch } from "../../../api/core";
import { useLoadedData } from "../../../hooks/useLoadedData";
import { useSmartList } from "../../../hooks/useSmartList"
import { Contact, Organization, OrganizationSchema } from "../types";
import { useOrganizationMerge } from "./useOrganizationsMerge";

export const useOrganizationsList = (apiPath: string) => {
  const organizationsApiPath = `${apiPath}/organization`
  const data = useSmartList<Organization>(`${organizationsApiPath}`, {
    newRecordDefault: {},
    getRecordApiPath: r => `${organizationsApiPath}/${r._id}`,
    editRecordSettings: {
      dontResetOnSave: true,
    },
    schema: OrganizationSchema,
    noView: true,
    textFilterApi: {
      paramName: "search",
    },
    skipTextFilter: true,
  });

  // 
  // EDITING
  // 

  const editedOrganizationContacts = useLoadedData<Contact[]>(
    `${organizationsApiPath}/${data.editRecord.item?._id}/contact`,
    [],
    !!data.editRecord.item?._id
  );

  useEffect(() => {
    if(!data.editRecord.item?._id) {
      editedOrganizationContacts.setData([]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.editRecord.item?._id])

  const findOrganization = (id: string) => apiFetch<Organization>(`${organizationsApiPath}/${id}`);

  const merge = useOrganizationMerge();

  return {
    ...data,
    editRecord: {
      ...data.editRecord,
      contacts: editedOrganizationContacts,
    },

    findOrganization,
    merge,
  };
}


export type OrganizationsListData = ReturnType<typeof useOrganizationsList>;
